import { useQuery } from '@tanstack/react-query'
import { useContext } from 'react'

import { PlaceDetailKeys } from '../reactQueryKeys'

import GeoContext from 'contexts/geoContext'
import { useGoogleMapsContext } from 'contexts/GoogleMapsContext'
import { PlaceResult } from 'tripPlanner/types/google'

type Args<T> = {
  placeId: string | undefined
  fields: T[]
}

const usePlaceDetails = <Field extends keyof PlaceResult>({
  placeId,
  fields,
}: Args<Field>) => {
  const { placesService } = useGoogleMapsContext()
  const { currentRegionCode } = useContext(GeoContext)

  const getPlaceDetails = () =>
    new Promise<PlaceResult | null>((resolve) => {
      if (placesService && placeId) {
        placesService.getDetails(
          { placeId, fields, region: currentRegionCode },
          (result, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
              resolve(result)
            } else {
              resolve(null)
            }
          },
        )
      } else {
        resolve(null)
      }
    })

  return useQuery<PlaceResult | null>(
    PlaceDetailKeys.googlePlaceDetail(fields, placeId),
    getPlaceDetails,
    {
      enabled: !!placesService,
    },
  )
}

export default usePlaceDetails
